import { CoverImageInput } from "@circle-react-uikit/CoverImageInput";
import { CoverImageInputPanel } from "@circle-react-uikit/CoverImageInput/CoverImageInputPanel";
import type { RendererProps } from "@circle-react-uikit/ImageInput/ImageSelector";
import { ASPECT_RATIO } from "@circle-react/components/constants";
import { useComposerSpace } from "@circle-react/components/QuickPostV3/hooks/useComposerSpace";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

import { t } from "@/i18n-js/instance";

const renderPreview = (props: RendererProps) => {
  if (!props.value && !props.processing) return null;
  return <CoverImageInputPanel {...props} removeButtonVariant="danger" />;
};

export const Cover = () => {
  const { hasCover } = useComposerSpace();

  return (
    <CoverImageInput
      name="cover_image"
      renderer={renderPreview}
      aspectRatio={ASPECT_RATIO.DEFAULT}
      changeImageText={t("replace")}
      className={classNames(
        "relative",
        hasCover &&
          "mb-3 [&_img]:h-[267px] [&_img]:w-full [&_img]:rounded-none [&_img]:object-cover",
      )}
    />
  );
};
